
import React from 'react';

const AboutSection = () => {
  return (
    <section className="mb-16">
      <h2 className="section-title-left mb-6">About Cats About Town Tours</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
        <div className="md:col-span-2">
          <p className="text-text/90 mb-6 font-lora">
            Cats About Town Tours is a unique historical walking tour company in New York City, dedicated to exploring the rich feline heritage of the city. Our tours highlight the significant roles cats have played in NYC's vibrant culture, uncovering fascinating stories of famous felines and their contributions to the city's history. Whether in Brooklyn or Lower Manhattan, we take you on an unforgettable journey through the city's past—one cat at a time.
          </p>
          <h3 className="font-playfair text-xl font-bold mb-3 text-primary">Our Mission</h3>
          <p className="text-text/90 font-lora">
            Our mission is to celebrate and preserve the stories of New York City's historical cats by providing engaging and educational experiences for cat lovers and history enthusiasts alike.
          </p>
        </div>
        <div className="md:col-span-1">
          <img 
            src="/lovable-uploads/80aaf0bb-f623-4861-9fa6-264d59e097ad.png" 
            alt="Tour guide showing historical photos of NYC cats" 
            className="rounded-md shadow-elegant w-full h-auto"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
